import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import Button from '@material-ui/core/Button';
import StarIcon from '@material-ui/icons/Star';
import s from './Navigation.css';
import ApplicationContext from '../ApplicationContext';
import getUser from '../../utils/getUser';
import UserMenu from './UserMenu/UserMenu';
import NavLink from './NavLink';
import MobileMenu from './MobileMenu';
import { isHubReleased } from '../../data/widgets/release';

/**
 * Верхнее меню
 * @returns {*}
 * @constructor
 */
export default function Navigation() {
	useStyles(s);

	// Отрендерить меню для пользователя
	function renderUser(user) {
		// Разделы для бургера в мобильной шапке
		const mobileLinks = [
			isHubReleased() && { href: '/widgets', title: 'Widgets' },
			{ href: '/themes', title: 'User themes' },
			{ href: '/support', title: 'Support' },
			{ href: '/invite', title: 'Invite friends' },
		].filter(Boolean);

		return (
			<div>
				{/* Мобильная шапка: бургер и профиль. Какую из двух показать,
				    решает CSS, а не JS — иначе меню прыгало бы после гидратации */}
				<div className={s.mobile} role="navigation">
					<MobileMenu links={mobileLinks} />
					<UserMenu user={user} mobile />
				</div>
				<div className={s.root} role="navigation">
					<NavLink show={isHubReleased()} href="/widgets">
						Widgets
					</NavLink>
					<NavLink show href="/themes">
						User themes
					</NavLink>
					<NavLink show={user} href="/themes/my">
						My themes
					</NavLink>
					<NavLink show href="/support">
						Support
					</NavLink>
					<NavLink show href="/invite">
						Invite friends
					</NavLink>
					{
						<NavLink
							href="/pro"
							color="secondary"
							variant="contained"
						>
							<StarIcon style={{ fontSize: 16 }} />
							&nbsp;PRO version
						</NavLink>
					}

					{!user && (
						<Button
							className={s.NavigationButton}
							href="/login/google"
							color="primary"
							variant="contained"
						>
							Sign in
						</Button>
					)}

					{user && false && (
						<Button
							className={s.NavigationButton}
							href="/logout"
							color="primary"
							variant="contained"
						>
							Logout
						</Button>
					)}
					<UserMenu user={user} />
				</div>
			</div>
		);
	}

	return (
		<ApplicationContext.Consumer>
			{({ context }) => <div>{renderUser(getUser(context))}</div>}
		</ApplicationContext.Consumer>
	);
}
